﻿$(document).ready(function () {
    
    $('[data-toggle="popover"]').popover();

    // Hide sticky when scroll on recap
    $(window).scroll(function () {
        majStickyVisibility();
    });
    majStickyVisibility();

    // Panitem
    // Modif Qte
    $('.select-options[data-selectname=detail-qte] li').click(function () {
        qte = $(this).attr('rel');

        id = $(this).closest('.cart-item').attr('data-id');

        $(this).closest('ul').find('li.selected').removeClass('selected');
        $(this).closest('ul li[rel=' + qte + ']').addClass('selected');
        
        // On met à jour la bdd
        $.ajax({
            type: "POST",
            url: "/ajax/panier.asmx/majpanitemqte",
            data: '{id: ' + id + ',qte : '+ qte +'}',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            failure: function (response) {
                TrackJS.track('ajax/panier.asmx/majpanitemqte (failure) { id: ' + id + ', qte: '+ qte +' } : ' + response.d);
            },
            error: function (response) {
                TrackJS.track('ajax/panier.asmx/majpanitemqte (error) { id: ' + id + ', qte: ' + qte + ' } : ' + response.d);
            }

        });

        // On majPanItem
        majPanItem(id, qte);

        // Maj livraison
        majLivraison();

        // On majTotal
        majTotal(true);
    });

    // Options Mobile deploiement des options
    $(".details-mobile").on("click", function () {
        optionmobilelist = $(this).parent().find('.options.mobile');
        if (optionmobilelist.is(':hidden')) {
            optionmobilelist.slideDown(500);
            $(this).find('.titre').html('Fermer');
        } else {
            optionmobilelist.slideUp(500);
            $(this).find('.titre').html('Détails & options');
        }   
    });
    
    //  --> Dialog 
    $(".options span.modifier").on('click', function () {
        initModifOptionLink(this);
    });

    // Hover titre du crayon (delegation pour les elements dynamiques)
    $(".cart-items-list").on('mouseenter', '.options span.modifier', function () {
        var titre = $(this).find('.titre');
        if (titre.length && titre.is(':hidden')) {
            titre.animate({ width: 'toggle' }, 150);
            $('.genericoverlay').show();
        }
    });
    $(".cart-items-list").on('mouseleave', '.options span.modifier', function () {
        var titre = $(this).find('.titre');
        titre.animate({ width: 'toggle' }, 0);
        $('.genericoverlay').hide();
    });
    

    // Del cav
    $(".recap .details-price .del").on('click', function () {
        initDelCavLink();
    });

    // CodePromo Checkbox
    $(".code-promo .prettyCheckbox").on("click", function () {
        if ($(".content-on").is(":visible")) {
            $(".content-on").hide();
            $(".content-off").show();

        } else {
            $(".content-off").hide();
            $(".content-on").show();
        }
    })

    // Validation d'un code promo
    $(".recap .details-price .code-promo-input input").keyup(function (event) {
        if (event.keyCode === 13) {
            $(".code-promo-input .btn").click();
        }
    });
    $(".code-promo-input .btn").on("click", function () {
        cav = $(".recap .details-price .code-promo-input input").val().trim();
        valideCav(cav);

        // On majTotal
        majTotal(false);
    });

    // Livraisons
    $(".livraison .titre").on("click", function () {
        $(".livraisonprop").toggleClass('nothidden');
        $(".livraison .titre").toggleClass('open');
    });
    $('.livraisonprop').on('click', function () {
        initChangeLivraison($(this));
    });

    function majStickyVisibility() {
        div_recap = $('.cart-recap-list .actions');
        if (is_visible_on_viewport(div_recap)) {
            $('.cart-recap-list .actions .sticky-bottom-mobile').removeClass('open');
        }
        else {
            $('.cart-recap-list .actions .sticky-bottom-mobile').addClass('open');
        }
    }

    function initModifOptionLink(obj) {
        var datas = $(obj).attr('data-optiondatas');

        // Charger le contenu via AJAX
        $('#dialog-options .modal-body').load('popUpOption.aspx?datas=' + datas, function () {
            // Event Valide choix option
            $('#btnValideOption').on('click', function () {
                valideModifOption();
            });

            // Masquer le contenu pendant le calcul initial pour éviter le "saut"
            $('#dialog-options .modal-body').css('visibility', 'hidden');

            // Ouvrir la modal Bootstrap
            $('#dialog-options').modal('show');
        });

        // Event après ouverture complète de la modal : calculer la hauteur
        $('#dialog-options').off('shown.bs.modal').on('shown.bs.modal', function () {
            calculateOptContentHeight();
            // Rendre visible après le calcul
            setTimeout(function() {
                $('#dialog-options .modal-body').css('visibility', 'visible');
            }, 10);

            // Observer les changements dans .opt-content pour recalculer automatiquement
            var optContentElement = $('.opt-content')[0];
            if (optContentElement && typeof MutationObserver !== 'undefined') {
                var recalculateTimeout;
                var isRecalculating = false;

                var observer = new MutationObserver(function(mutations) {
                    // Ignorer les mutations si on est déjà en train de recalculer
                    if (isRecalculating) return;

                    // Vérifier si des éléments .radio-col sont devenus visibles (spécifique à "Voir les suivants")
                    var hasRadioColChange = false;
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                            var target = $(mutation.target);
                            if (target.hasClass('radio-col') || target.closest('.radio-col').length > 0) {
                                hasRadioColChange = true;
                            }
                        }
                    });

                    if (hasRadioColChange) {
                        isRecalculating = true;

                        clearTimeout(recalculateTimeout);
                        recalculateTimeout = setTimeout(function() {
                            // Attendre que le navigateur ait fini de rendre les nouveaux items
                            requestAnimationFrame(function() {
                                calculateOptContentHeight();
                                isRecalculating = false;
                            });
                        }, 100);
                    }
                });

                observer.observe(optContentElement, {
                    attributes: true,
                    subtree: true,
                    attributeFilter: ['style']
                });

                // Nettoyer l'observer à la fermeture
                $('#dialog-options').one('hidden.bs.modal', function() {
                    observer.disconnect();
                });
            }
        });

        // Event de fermeture : nettoyer le contenu
        $('#dialog-options').off('hidden.bs.modal').on('hidden.bs.modal', function () {
            $(this).find('.modal-body').html('');
        });
    }

    function calculateOptContentHeight() {
        // Attendre que les images soient chargées
        var totalImages = $('.option-content img').length;

        if (totalImages > 0) {
            var imagesLoaded = 0;
            $('.option-content img').each(function () {
                if (this.complete) {
                    imagesLoaded++;
                    if (imagesLoaded === totalImages) {
                        applyOptContentHeight();
                    }
                } else {
                    $(this).on('load', function () {
                        imagesLoaded++;
                        if (imagesLoaded === totalImages) {
                            applyOptContentHeight();
                        }
                    });
                }
            });
        } else {
            applyOptContentHeight();
        }
    }

    function applyOptContentHeight() {
        var optContent = $('.opt-content');
        var modalHeader = $('#dialog-options .modal-header');
        var entete = $('.entete.first');
        var barreValide = $('.barre-valide');
        var modalBody = $('#dialog-options .modal-body');
        var modalContent = $('#dialog-options .modal-content');
        var type = $('.type');

        // Calculer depuis la hauteur viewport
        var viewportHeight = $(window).height();
        var modalMaxHeight = $(window).width() < 992 ? (viewportHeight - 30) : viewportHeight * 0.9;

        // Calcul des hauteurs
        var headerHeight = modalHeader.outerHeight(true) || 0;
        var enteteHeight = entete.outerHeight(true) || 0;
        var barreValideHeight = barreValide.outerHeight(true) || 0;
        var bodyPaddingTop = parseInt(modalBody.css('padding-top')) || 0;
        var bodyPaddingBottom = parseInt(modalBody.css('padding-bottom')) || 0;

        // Paddings et borders du modal-content
        var contentPaddingTop = parseInt(modalContent.css('padding-top')) || 0;
        var contentPaddingBottom = parseInt(modalContent.css('padding-bottom')) || 0;
        var contentBorderTop = parseInt(modalContent.css('border-top-width')) || 0;
        var contentBorderBottom = parseInt(modalContent.css('border-bottom-width')) || 0;

        // Padding du conteneur .type
        var typePaddingBottom = parseInt(type.css('padding-bottom')) || 0;
        var secutiryMargin = 20;
        var availableHeight = modalMaxHeight - headerHeight - enteteHeight - barreValideHeight - bodyPaddingTop - bodyPaddingBottom - contentPaddingTop - contentPaddingBottom - contentBorderTop - contentBorderBottom - typePaddingBottom - secutiryMargin;

        // Vérifier si le contenu nécessite vraiment une hauteur fixe
        var naturalContentHeight = optContent[0].scrollHeight;
        var totalNaturalHeight = headerHeight + enteteHeight + naturalContentHeight + typePaddingBottom + barreValideHeight + bodyPaddingTop + bodyPaddingBottom + contentPaddingTop + contentPaddingBottom + contentBorderTop + contentBorderBottom + secutiryMargin;

        // Toujours forcer une hauteur fixe si on est proche de la limite
        if (totalNaturalHeight > (modalMaxHeight - 50)) {
            // Le contenu est grand ou proche de la limite : forcer une hauteur fixe pour le scroll
            // Sécurité : hauteur minimum
            if (availableHeight < 200) {
                availableHeight = 200;
            }

            if ($(window).width() < 992) {
                modalContent.css('height', 'calc(100vh - 30px)');
            } else {
                modalContent.css('height', '90vh');
            }

            optContent.css({
                'height': availableHeight + 'px',
                'overflow-y': 'auto',
                'overflow-x': 'hidden'
            });
        } else {
            // Le contenu est vraiment petit : laisser la modal s'adapter naturellement
            modalContent.css('height', 'auto');
            optContent.css({
                'height': 'auto',
                'overflow-y': 'visible'
            });
        }
    }

    function initDelCavLink() {
        $.ajax({
            type: "POST",
            url: "/ajax/panier.asmx/removecav",
            data: '',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (response) {
                $("input:hidden[data-id='cavHidden']").val('');

                ulRecap = $('.recap .details-price');
                ulRecap.find('li.promo-resum:not(.hide)').remove();

                $('.recap .details-price .code-promo').removeClass('hide');
            },
            failure: function (response) {
                TrackJS.track("ajax/panier.asmx/removecav (failure) : " + response.d);
            },
            error: function (response) {
                TrackJS.track("ajax/panier.asmx/removecav (error) : " + response.d);
            }
        });

        // On majTotal
        majTotal(false);
    }

    function initChangeLivraison(obj) {
        prix = obj.find('.prix').attr('data-livraisonprop');

        // Coupon "livraison offerte" : on affiche "Offerte" (data-livraison reste le prix reel pour le total)
        $('.livraison .livtotal').html(prolivinclude ? 'Offerte' : prix.replace('.', ',') + ' &euro;');
        $('.livraison .livtotal').attr('data-livraison', prix);

        $("input:hidden[data-id='livHidden']").val(obj.attr('data-id'));

        $(".livraisonprop").removeClass('selected');
        obj.addClass('selected');

        // On majTotal
        majTotal(false);
    }

    function majLivraison() {
        livselected = $("input:hidden[data-id='livHidden']").val();

        $.ajax({
            type: "POST",
            url: "/ajax/panier.asmx/getlivraisons",
            data: JSON.stringify({
                pan: JSON.stringify(window.panierData),
                cli: cli
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (response) {
                var livraisonObjects = JSON.parse(response.d);

                ulRecap = $('.recap .details-price');
                ulRecap.find('li.livraisonprop:not(.template)').remove();
                liTemplate = ulRecap.find('.livraisonprop.template');

                // !! IE
                //livexist = livraisonObjects.some(item => item.LIVTYP_ID == livselected);
                livexist = livraisonObjects.some(function (item) {
                    return item.LIVTYP_ID == livselected;
                });
                //livexist = true;

                $.each(livraisonObjects, function (index) {
                    liTemplateTemp = liTemplate.clone();

                    liTemplateTemp.attr('data-id', this.LIVTYP_ID);

                    liTemplateTemp.find('.titre').html(this.LIVTYP_TITRE);
                    liTemplateTemp.find('.delais').html('Reception entre le ' + this.LIVTYP_DATEMIN + ' et le ' + this.LIVTYP_DATEMAX);

                    prix = parseFloat(this.LIVTYP_PRIX);

                    liTemplateTemp.find('.prix').html(prix.toFixed(2).replace('.', ',') + ' &euro;');
                    liTemplateTemp.find('.prix').attr('data-livraisonprop', prix.toFixed(2).replace(',', '.'));

                    liTemplateTemp.on('click', function () {
                        initChangeLivraison($(this));
                    });

                    // Maj de la livraison selectionnée
                    if (((!livexist) && index == 0) || (livexist && livselected == this.LIVTYP_ID)) {
                        // Coupon "livraison offerte" : on affiche "Offerte" (data-livraison reste le prix reel)
                        $('.livraison .livtotal').html(prolivinclude ? 'Offerte' : prix.toFixed(2).replace('.', ',') + ' &euro;');
                        $('.livraison .livtotal').attr('data-livraison', prix.toFixed(2));
                        liTemplateTemp.addClass("selected");

                        $("input:hidden[data-id='livHidden']").val(this.LIVTYP_ID);
                    }

                    liTemplateTemp.removeClass('template');

                    $('.recap .details-price .code-promo').before(liTemplateTemp);

                    // On ferme la liste des livraison
                    $(".livraison .titre").removeClass('open');
                    $(".livraisonprop").removeClass('nothidden');
                });
            },
            failure: function (response) {
                TrackJS.track('ajax/panier.asmx/getlivraisons (failure) {pan: "' + pan + '",cli:"'+cli+'"} : ' + response.d);
            },
            error: function (response) {
                TrackJS.track('ajax/panier.asmx/getlivraisons (error) {pan: "' + pan + '",cli:"' + cli + '"} : ' + response.d);
            }
        });
    }

    function majPanItem(id, qte) {
        $.ajax({
            type: "POST",
            url: "/ajax/panier.asmx/getpanitem",
            data: '{id: ' + id + '}',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (response) {
                var panitemObject = JSON.parse(response.d);
                panitem = $('.cart-item[data-id="' + id + '"]');

                sstot = (panitemObject.ss_total_qte + panitemObject.ss_total_optionsNonAffectPrice).toFixed(2);
                panitem.find('.sstotalligne').html(sstot.replace('.', ',') + ' &euro;');
                panitem.find('.sstotalligne').attr('data-sstotal', sstot);
                panitem.find('.puvalue').html(panitemObject.prod_pu.toFixed(2).replace('.', ',') + ' &euro;');

                // Options
                panItemUlOptions = panitem.find('.options ul');
                panItemUlOptions.find('.toupdate').remove();

                $.each(panItemUlOptions, function (i,ul) {
                    liTemplate = $(ul).find('.template');

                    $.each(panitemObject.l_options, function (j,pi) {
                        liTemplateTemp = liTemplate.clone();

                        liTemplateTemp.attr('data-id', pi.opt_id);
                        liTemplateTemp.attr('data-typ-code', pi.typopt_code);
                        liTemplateTemp.attr('data-code', pi.opt_code);

                        liTemplateTemp.find('.libelle').html(pi.opt_libelle);

                        link_modifier = liTemplateTemp.find('.modifier');
                        link_modifier.attr('data-optiondatas', pi.md5_datas);
                        if (!link_modifier.hasClass('mobile')) {
                            link_modifier.find('.titre').text("Modifier " + pi.opt_libelle);
                        }

                        liTemplateTemp.removeClass('template').addClass('toupdate');
                        //if (pi.typopt_code == "TRANQ") {
                        //    liTemplateTemp.addClass('tranq');
                        //    libel = liTemplateTemp.find('.libelle');
                        //    libel.attr("data-placement", "bottom");
                        //    libel.attr("data-trigger", "hover");
                        //    libel.attr("data-html", "true");
                        //    libel.attr("data-content", "Une de nos graphistes vérifiera dans les moindres détails votre création avant impression : mise en page, orthographe, grammaire, ...");

                        //    libel.popover();
                        //}
                        liTemplateTemp.appendTo($(ul));

                        // reactive popover
                        liTemplateTemp.find('.libelle').popover();

                        liTemplateTemp.find('.modifier').on('click', function () {
                            //initModifOptionLink(liTemplateTemp.find('.modifier'));
                            initModifOptionLink(this);
                        });
                    });
                });

                // On met à jour window.panierData
                window.syncPanierDataFromSession();
            },
            failure: function (response) {
                TrackJS.track('ajax/panier.asmx/getpanitem (failure) {id: ' + id + '} : ' + response.d);
            },
            error: function (response) {
                TrackJS.track('ajax/panier.asmx/getpanitem (error) {id: ' + id + '} : ' + response.d);
            }
        });
    }

    // Met à jour l'affichage du résumé des echant gratuits
    function majEchantillonsGratuitsTotal() {
        var nbEchantillons = window.panierData.Statistics.FreeEchantillon.NbReallyFree;
        var pluriel = nbEchantillons > 1 ? "s" : "";
        $('.echant-resum .titre').text(`${nbEchantillons} échantillon${pluriel} offert${pluriel}`);
        $('.echant-resum .prix').html('-' + window.panierData.Statistics.FreeEchantillon.TotalRemise.toFixed(2).replace('.', ',') + ' &euro;');
        $('.echant-resum .prix').attr('data-remiseechant', window.panierData.Statistics.FreeEchantillon.TotalRemise.toFixed(2));

        var showResum = window.panierData.Statistics.FreeEchantillon.TotalRemise > 0;
        if (showResum) {
            $('.echant-resum').removeClass('hide');            
        }
        else {
            $('.echant-resum').addClass('hide');
        }
        

        var showError = window.panierData.Statistics.FreeEchantillon.HasEchantillonsDemandesNonGratuits;
        if (showError) {
            $('.echant-error').removeClass('hide');
        } else {
            $('.echant-error').addClass('hide');
        }
    }
    
    function majTotal(withcav) {
        var soustotal = 0;

        $('.cart-item').each(function (index,panitem) {
            sstotalitem = $(this).find('.sstotalligne').attr('data-sstotal');
            soustotal += parseFloat(sstotalitem);
        });

        $('#soustotal').html(soustotal.toFixed(2).replace('.', ',') + ' &euro;');
        
        totallivraison = 0;
        $('[data-livraison]').each(function () {
            livraison = $(this).attr('data-livraison');
            totallivraison += parseFloat(livraison);
        });

        if (withcav) {
            $("input:hidden[data-id='ssTotalHidden']").val(soustotal.toFixed(2));// !important pour le calcul du cav
            cav = $("input:hidden[data-id='cavHidden']").val();
            valideCav(cav);
        }

        majCavTotal(totallivraison);

        totalremise = 0;
        $('[data-remise]').each(function () {
            remise = $(this).attr('data-remise-with-livraison');
            if (remise) {
                totalremise += parseFloat(remise);
            }
        });

        // 
        majEchantillonsGratuitsTotal();

        var remiseEchant = $('.echant-resum .prix').attr('data-remiseechant');
        remiseEchant = parseFloat(remiseEchant) || 0;
        soustotal = soustotal - remiseEchant;

        $("input:hidden[data-id='ssTotalHidden']").val(soustotal.toFixed(2));

        // Total
        var total = soustotal - totalremise + totallivraison;
        total = Math.round(total * 100) / 100;
        $("#total,#totalmob").html(total.toFixed(2).replace('.', ',') + ' &euro;');
    }

    function valideModifOption() {
        panitemdatas = $('.panitemdatas').val();
        type = $('.typedisplay').val();
        panitemid = $('.panitemid').val();

        jsonOptions = [];

        isModifPapier = false;
        if (type === 'CHECKBOX') {
            checkbox = $('.checkbox').find("input:checkbox");
            id = checkbox.attr('data-id');
            ischecked = checkbox.is(':checked');

            if (ischecked) {
                optionItem = new Object();
                optionItem.id = parseInt(id);
                optionItem.qte = 1;
                jsonOptions.push(optionItem);
            }
        }
        else if (type === 'SELECT') {
            select = $(".select-content select").children('option:selected');
            id = select.val();

            if (id) {
                optionItem = new Object();
                optionItem.id = parseInt(id);
                optionItem.qte = 1;
                jsonOptions.push(optionItem);
            }
        }
        else if (type === 'RADIO' || type === 'CAROUSSEL') {
            radio = $(".radio-content input:radio");
            typcode = radio.attr("name");

            if (typcode == 'PAPIER') {
                isModifPapier = true;
            }

            id = $("input:hidden[data-typcode='" + typcode + "']").val();	

            if (id!=-1) {
                optionItem = new Object();
                optionItem.id = parseInt(id);
                optionItem.qte = 1;
                jsonOptions.push(optionItem);
            }
        }
        else if (type === 'MULTSELECT') {
            $(".multiselect-content select").each(function () {
                qteSelected = $(this).children('option:selected').val();

                if (qteSelected > 0) {
                    id = $(this).attr('optid');

                    optionItem = new Object();
                    optionItem.id = parseInt(id);
                    optionItem.qte = qteSelected;
                    jsonOptions.push(optionItem);
                }
            });
        }

        SjsonOptions = JSON.stringify(jsonOptions);
        datas = "{'panitemdatas': '" + panitemdatas + "','optiondatas':'" + SjsonOptions + "'}";
        var panierItemRemoved = false;
        $.ajax({
            type: "POST",
            url: "/ajax/panier.asmx/majpanitemoption",
            data: datas,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (response) {
                if (response && response.d === "ko_item_removed") {
                    panierItemRemoved = true;
                }
            },
            failure: function (response) {
                TrackJS.track("ajax/panier.asmx/majpanitemoption (failure) {'panitemdatas': '" + panitemdatas + "','optiondatas':'" + SjsonOptions + "'} : " + response.d);
            },
            error: function (response) {
                TrackJS.track("ajax/panier.asmx/majpanitemoption (error) {'panitemdatas': '" + panitemdatas + "','optiondatas':'" + SjsonOptions + "'} : " + response.d);
            }
        });

        if (panierItemRemoved) {
            // Panier desynchronise (onglet obsolete ou item supprime ailleurs) : on recharge.
            location.reload();
            return;
        }

        // Cas de la mise à jour du papier, on va chercher le pelliculage dans le panieritem s'il existe
        if (isModifPapier) {
            panitem = $('.cart-item[data-id="' + panitemid + '"]');
            firstpapierchecked = $("#PAPIER").find(".radio").first().hasClass('checked');

            if (panitem.find('li[data-typ-code="PELLICUL"]').length > 0 && !firstpapierchecked) {
                jsonOptions = [];

                liVernis = panitem.find('li[data-typ-code="PELLICUL"]');
                panItemDatasVernis = liVernis.find('.modifier').attr('data-optiondatas');

                SjsonOptions = JSON.stringify(jsonOptions);
                datas = "{'panitemdatas': '" + panItemDatasVernis + "','optiondatas':'" + SjsonOptions + "'}";
                $.ajax({
                    type: "POST",
                    url: "/ajax/panier.asmx/majpanitemoption",
                    data: datas,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    async: false,
                    success: function (response) {
                        if (response && response.d === "ko_item_removed") {
                            panierItemRemoved = true;
                        }
                    },
                    failure: function (response) {
                        TrackJS.track("ajax/panier.asmx/majpanitemoption (failure) {'panitemdatas': '" + panitemdatas + "','optiondatas':'" + SjsonOptions + "'} : " + response.d);
                    },
                    error: function (response) {
                        TrackJS.track("ajax/panier.asmx/majpanitemoption (error) {'panitemdatas': '" + panitemdatas + "','optiondatas':'" + SjsonOptions + "'} : " + response.d);
                    }
                });

                if (panierItemRemoved) {
                    location.reload();
                    return;
                }
            }
        }

        // On majPanItem
        majPanItem(panitemid);

        // On majTotal
        majTotal();

        $("#dialog-options").modal('hide');
    }

    function valideCav(cav,totalLivraison) {

        if (cav.trim() != "") {
            var inputcav = $(".recap .details-price .code-promo-input input");

            sstotal = $("input:hidden[data-id='ssTotalHidden']").val();

            $.ajax({
                type: "POST",
                url: "/ajax/panier.asmx/validecav",
                data: '{cav: "' + cav + '",sstotal:' + sstotal +',pan:"'+pan+'",cli:"'+cli+'"}',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                async: false,
                success: function (response) {
                    var remiseObject = JSON.parse(response.d);

                    message = remiseObject.message;
                    retour_promo = JSON.parse(remiseObject.retour_promo);

                    if (!retour_promo.is_remised) {
                        prolivinclude = false;

                        swal("", message);

                        initDelCavLink();
                    }
                    else {
                        prolivinclude = retour_promo.livraison_include;

                        totalremise = retour_promo.total.toFixed(2);

                        ulRecap = $('.recap .details-price');
                        ulRecap.find('li.promo-resum:not(.hide)').remove();
                        $('.recap .details-price .code-promo').addClass('hide');

                        liTemplate = ulRecap.find('.promo-resum.hide');
                        liTemplateTemp = liTemplate.clone();

                        liTemplateTemp.find('.titre').html(retour_promo.titre);
                        liTemplateTemp.find('.promodescr').html(retour_promo.description + ' ' + retour_promo.texte_cumulatif);

                        remise = parseFloat(retour_promo.total);                   

                        liTemplateTemp.find('.right').html('-' + remise.toFixed(2).replace('.', ',') + ' &euro;');
                        liTemplateTemp.find('.right').attr('data-remise', remise.toFixed(2).replace(',', '.'));
                        liTemplateTemp.find('.right').attr('data-remise-with-livraison', parseFloat(retour_promo.total_with_livraison).toFixed(2).replace(',', '.'));
                        liTemplateTemp.find('.del').on('click', function () {
                            initDelCavLink();
                        });

                        liTemplateTemp.removeClass('hide');
                        liTemplate.after(liTemplateTemp);

                        $("input:hidden[data-id='cavHidden']").val(cav);
                    }
                
                    inputcav.val('');
                },
                failure: function (response) {
                    TrackJS.track('ajax/panier.asmx/validecav (failure) {cav: "' + cav + '",sstotal:' + sstotal + ',pan:"' + pan + '",cli:"' + cli +'"} : ' + response.d);
                },
                error: function (response) {
                    TrackJS.track('ajax/panier.asmx/validecav (error) {cav: "' + cav + '",sstotal:' + sstotal + ',pan:"' + pan + '",cli:"' + cli +'"} : ' + response.d);
                }
            });
        }
    }

    function majCavTotal(totalLivraison) {
        ulRecap = $('.recap .details-price');
        li_promo = ulRecap.find('li.promo-resum:not(.hide)');

        if (li_promo.length) {
            var remiseArticles = parseFloat(li_promo.find('.right').attr('data-remise'));

            // Affichage : remise sur les articles seuls (le port s'affiche "Offerte" cote livraison).
            li_promo.find('.right').html('-' + remiseArticles.toFixed(2).replace('.', ',') + ' &euro;');

            // Calcul : data-remise-with-livraison reste gonfle du port quand le coupon l'offre, pour que
            // le total reste correct (soustotal - remise_gonflee + port = soustotal - remise_articles).
            var remiseCalcul = remiseArticles + ((prolivinclude && totalLivraison) ? parseFloat(totalLivraison) : 0);
            li_promo.find('.right').attr('data-remise-with-livraison', remiseCalcul.toFixed(2).replace(',', '.'));

            if (prolivinclude) {
                $('.livraison .livtotal').html('Offerte');
            }
        }
    }

    // Valider le panier : redirige vers commande.aspx (mode invite supporte par checkout 2026,
    // creation silencieuse du compte au paiement via CreateClientSilently).
    $(".btn_valider_panier").on("click", function () {
        __doPostBack('BT_ValiderCommande', '');
    });

    // popup CrossSelling
    var swiperPropo = null;

    function showAddToCartPopup() {
        $('#cartAddedModal').modal('show');
    }

    // Initialiser Swiper avec observer pour recalculer quand la modal devient visible
    if ($('#swiper-propo').length > 0) {
        swiperPropo = new Swiper('#swiper-propo', {
            slidesPerView: 4.8,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.nav-button-main.right',
                prevEl: '.nav-button-main.left'
            },
            breakpoints: {
                767: {
                    slidesPerView: 1.6,
                    spaceBetween: 0,
                },
                991: {
                    slidesPerView: 3.6,
                    spaceBetween: 0,
                },
            }
        });
    }

    $('.view-cart-button').on('click', function () {
        // Fermer la modal
        $('#cartAddedModal').modal('hide');
    });

    // Clic sur personnaliser un produit suggéré
    $('.customize-button').on('click', function () {
        var module = $(this).attr('data-module');

        if (module == 'NONE') {
            var urlfiche = $(this).attr('data-urlfiche');
            location.href = urlfiche;
        }
        else {
            var qrp = $(this).attr('data-qrp');

            if (module == 'MCLIP') {
                var qrptheme = $(this).attr('data-qrptheme');

                qrp = qrp + qrptheme;
            }

            openModule("panier", module, qrp);
        }
    });


    if (!$('#cartAddedModal').hasClass('in')) {
        $('#cartAddedModal').css('display', 'none');
    }

    if (!$('#productZoomModal').hasClass('in')) {
        $('#productZoomModal').css('display', 'none');
    }

    if (showpropo)
        showAddToCartPopup();
    else
        $('#cartAddedModal').modal('hide');

    // Variable pour stocker l'instance Swiper
    var swiperZoom = null;

    // Gestion du clic sur les images produit pour le zoom
    $(document).on('click', '.cart-item .visuel img', function(e) {
        e.preventDefault();

        var zoomImagesAttr = $(this).attr('data-zoom-images');

        if (zoomImagesAttr) {
            try {
                var zoomImages = JSON.parse(zoomImagesAttr);
                showProductZoom(zoomImages);
            } catch (error) {
                TrackJS.track('Erreur parsing data-zoom-images: ' + error);
                // Fallback sur l'image actuelle en cas d'erreur
                var currentImageUrl = $(this).attr('src');
                showProductZoom([currentImageUrl]);
            }
        } else {
            // Fallback sur l'image actuelle si pas de data-zoom-images
            var currentImageUrl = $(this).attr('src');
            showProductZoom([currentImageUrl]);
        }
    });

    function showProductZoom(imageUrls) {
        // Détruire l'instance Swiper existante si elle existe
        if (swiperZoom) {
            swiperZoom.destroy(true, true);
            swiperZoom = null;
        }

        // Vider les slides existantes
        $('#swiper-zoom .swiper-wrapper').empty();

        // Ajouter les nouvelles slides
        imageUrls.forEach(function(url) {
            var slide = $('<div class="swiper-slide"><img src="' + url + '" alt="Product zoom" /></div>');
            $('#swiper-zoom .swiper-wrapper').append(slide);
        });

        // Ouvrir la modal
        $('#productZoomModal').modal('show');

        // Initialiser Swiper après l'ouverture de la modal
        $('#productZoomModal').one('shown.bs.modal', function () {
            swiperZoom = new Swiper('#swiper-zoom', {
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.zoom-nav-next',
                    prevEl: '.zoom-nav-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            });
        });
    }

    // Nettoyer Swiper à la fermeture de la modal
    $('#productZoomModal').on('hidden.bs.modal', function () {
        if (swiperZoom) {
            swiperZoom.destroy(true, true);
            swiperZoom = null;
        }
    });
});

// googleAnalytics
function confirmDelete(ctl, event) {
    
    var defaultAction = $(ctl).prop("href");
    
    event.preventDefault();
    swal({
        title: "Etes-vous sûr(e) de vouloir enlever ce produit de votre panier?",
        text: "",
        type: "warning",
        showCancelButton: true,
        customClass:'deleteduplicatepanier',
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        closeOnConfirm: true,
        closeOnCancel: true
    },
        function (isConfirm) {
            if (isConfirm) {

                panitemdata = $(ctl).attr('gadata').split('|');

                // GTM
                prodid = $(ctl).attr('data-prodid');
                if (typeof window.gtm_items_panier !== 'undefined') {
                    var gtm_item = window.gtm_items_panier.filter(function (item) {
                        if (item.item_id === prodid)
                            return item;
                    });

                    processRemovePanierClick(defaultAction, gtm_item, panitemdata);
                }
                else {
                    window.location.href = defaultAction;
                }
                
                return true;
            } else {
                return false;
            }
        });
}

// GTM send and redirect
function processRemovePanierClick(url, gtm_item,item_removed) {
    if (window['google_tag_manager']) {
        gtm_remove_from_cart(gtm_item, item_removed, url);
    }
};

function confirmDuplicate(ctl, event) {
    var defaultAction = $(ctl).prop("href");
    
    event.preventDefault();
    swal({
        title: "Etes-vous sûr(e) de vouloir dupliquer ce produit dans votre panier?",
        text: "",
        type: "warning",
        showCancelButton: true,
        customClass: 'deleteduplicatepanier',
        confirmButtonText: "Dupliquer",
        cancelButtonText: "Annuler",
        closeOnConfirm: true,
        closeOnCancel: true
    },
        function (isConfirm) {
            if (isConfirm) {
                window.location.href = defaultAction;
                return true;
            } else {
                return false;
            }
        });
}

function is_visible_on_viewport(obj) {
    if (obj.length > 0) {
        var top_of_element = obj.offset().top;
        var bottom_of_element = obj.offset().top + $('.cart-recap-list').outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
            return true;
        } else {
            return false;
        }
    }
    else
        return false;
}


